module.exports = __webpack_public_path__ + "static/media/VsdchengRules.11d178f6.pdf";